import { v4 as uuidv4 } from 'uuid';

export const getGuestId = () => {
    let guestId = localStorage.getItem('guestId');
    if (!guestId) {
        guestId = uuidv4();
        localStorage.setItem('guestId', guestId);
    }
    return guestId;
};

export const clearGuestId = () => {
    localStorage.removeItem('guestId');
};

export const getSessionId = () => {
    let sessionId = localStorage.getItem('sessionId');
    if (!sessionId) {
        sessionId = uuidv4();
        localStorage.setItem('sessionId', sessionId);
    }
    return sessionId;
};
